import React from "react";
import { useTranslation } from "react-i18next";
import { Row } from "../Row";

interface Props {
  payments: Array<any>;
  isCaseClosed?: boolean;
}
const PaymentItems: React.FC<Props> = ({ payments, isCaseClosed }) => {
  const { t } = useTranslation();
  return (
    <div className="map-item-table pr-2">
      {payments?.map(
        ({
          arItemNo,
          amount,
          caseNo,
          transactionItemTypeId,
        }: {
          arItemNo: string;
          amount: number;
          caseNo: string;
          caseId: number;
          caseType: string;
          transactionItemTypeId: number;
        }) => (
          <Row
            key={arItemNo}
            amount={amount}
            label={`${t("US.COLLECTION.ECONOMY:MANAGE_PAYMENTS.CASE_NO")} : `}
            caseNo={caseNo}
            itemTypeId={transactionItemTypeId}
          />
        )
      )}
    </div>
  );
};

export default PaymentItems;
